
// src/connects/kpi-chart-detail-table.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import lifecycle from '../helpers/lifecycle'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import { emitAlertMessage } from '../actions/alert-message'
import moment from 'moment'
import each from 'lodash/each'
import map from 'lodash/map'
import find from 'lodash/find'

export function initSkipRows(progress, user_id) {
  const actual_records = find(progress, (item)=> item.user_id == user_id).actual_records
  var result = []
  each(actual_records, (record, i)=> {
    if (record.actual || i == 0) {
      var j
      for (j = 0; i + j + 1 < actual_records.length && !actual_records[i + j + 1].actual; j ++)
        result[i + j + 1] = { skip: true }
      result[i] = { skip_count: j }
    }
  })
  return result
}

// This function is used to filter the actual_records by date ranges from original actual_records and re-calculate the "total" field based on filtered_records
export function filterActualRecords(actual_records, accumulated_total, aggregationType, tableSelectedDate, tableStartDate, tableEndDate) {
  const dateRange = [new Date(tableStartDate), new Date(tableEndDate)]
  let filtered_records = actual_records.filter(item => {
    const reportedDate = new Date(item.reported_at)
    return reportedDate >= dateRange[0] && reportedDate <= dateRange[1]
  })
  // Calculate the cumulative daily target
  if (filtered_records.length > 0) {
    const daily_target = accumulated_total ? filtered_records[0].target / filtered_records.length : filtered_records[0].target
    filtered_records.forEach((item, index) => {
      item.cumulative_target = daily_target * (index + 1)
      item.daily_target = daily_target
      item.total_target = daily_target * filtered_records.length
    })
  }
  let cumulativeTotal = 0
  filtered_records = filtered_records.map(record => {
    cumulativeTotal += record.actual
    return { ...record, total: cumulativeTotal }
  })
  // if (aggregationType != 'cumulative') {
  //   const selectedDateRange =  [new Date(tableSelectedDate), new Date(tableSelectedDate)]
  //   filtered_records = filtered_records.filter(item => {
  //     const reportedDate = new Date(item.reported_at)
  //     return reportedDate >= selectedDateRange[0] && reportedDate <= selectedDateRange[1]
  //   })
  // }
  return filtered_records;
}

export function initTotalSkipRows(selectedKPIs, kpis, user_id, aggregationType, tableSelectedDate, tableStartDate, tableEndDate) {
  var result = []
  map(selectedKPIs, (selected_kpi, i) => {
    const kpi = kpis.find(item => item.kpi_id == selected_kpi.kpi_id);
    if (kpi) {
      const assignment = find(kpi.assignments, (item)=> item.user_id == user_id);

      if (assignment && assignment.progress && assignment.progress.actual_records) {
        const filtered_records = filterActualRecords(assignment.progress.actual_records, true, aggregationType, tableSelectedDate, tableStartDate, tableEndDate)
        
        // Ensure result[i] is initialized as an array
        result[i] = result[i] || [];
        
        each(filtered_records, (record, j)=> {
          // Ensure result[i][j] is initialized as an object
          result[i][j] = result[i][j] || {};

          if (record.actual || j == 0) {
            let k;
            for (k = 0; j + k + 1 < filtered_records.length && !filtered_records[j + k + 1].actual; k++) {
              result[i][j + k + 1] = result[i][j + k + 1] || {}; // Initialize if undefined
              result[i][j + k + 1].skip = true;
            }
            result[i][j].skip_count = k;
          }
        })
      }
    }
  })

  return result
}

export function prepareActualRecords(progress, user_id) {
  return map(find(progress, (item)=> item.user_id == user_id).actual_records, (record)=> {
    const total = typeof record.total == 'undefined' ? record.actual : record.total
    return Object.assign({}, record, {
      percent: Math.floor(total * 1000 / record.target) / 1000
    })
  })
}

export function getActualRecords(assignments, user_id, accumulated_total, aggregationType, tableSelectedDate, tableStartDate, tableEndDate) {
  const assignment = find(assignments, (item) => item.user_id == user_id);

  if (!assignment || !assignment.progress || !assignment.progress.actual_records) {
    return []; // Return an empty array if progress or actual_records is missing
  }
  const filtered_records = filterActualRecords(assignment.progress.actual_records, accumulated_total, aggregationType, tableSelectedDate, tableStartDate, tableEndDate)

  let total = 0
  let target = 0
  return map(filtered_records, (record) => {
    switch(aggregationType) {
      case 'cumulative':
        total = record.total 
        target = accumulated_total ? record.target : record.total_target
        break
      case 'daily_total_01':
        total = record.actual
        target = record.daily_target
        break
      case 'daily_total_02':
        total = record.total
        target = record.cumulative_target
        break
    }

    return Object.assign({}, record, {
      tbl_total: total,
      tbl_target: target,
      percent: Math.floor(total * 1000 / target) / 1000,
    });
  });
}

export function arrayInTotal(progress, user_id) {
  if(progress) {
    //actual_records内にtotalがある場合か判定
    const recordDate = find(progress, (item)=> item.user_id == user_id).actual_records
    if(recordDate) return ("total" in recordDate[0])
  }
  return false
}

export const mapStateToProps = (state, ownProps)=> {
  return {
    isUpdating: state.kpiChart.isUpdating,
    isUpdateFailed: state.kpiChart.isUpdateFailed,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    toggleSkipRows: (props, i, j) => {
      const skip_count = props.ui.skipRows[i][j] && props.ui.skipRows[i][j].skip_count || 0;
      const skipRows = map(props.ui.skipRows, (rowGroup, rowIndex) => {
        if (rowIndex != i) return rowGroup;
    
        return map(rowGroup, (row, colIndex) => {
          if (colIndex <= j) return row;
          if (colIndex > j + skip_count) return row;
          return { ...row, skip: !row.skip };
        });
      });
    
      props.updateUI({ skipRows });
    },

    displayGroupMemberErrorMessage: (group_name)=> {
      dispatch(emitAlertMessage({ message: 'label:この値は変更できない', group_name: group_name}, 'error'))
    },

    updateActualRecord: (kpi_id, kpi_name, reported_at, value)=> {
      dispatch(
        actions.updateKpiActualRecord(
          kpi_id,
          reported_at,
          value,
          ownProps.group.group_id,
          ownProps.selected_user_id,
        )
      ).then(() => {
        // fetch Update data from selectedKPIs
        ownProps.fetchChartKpis(ownProps.selectedKPIs, ownProps.parentProps);
        ownProps.fetchComparisonKpis(ownProps.selectedKPIs, ownProps.parentProps);  
      });
      dispatch(emitAlertMessage({ message: 'label:KPIの実績値を更新しました', name: kpi_name, reported_at: moment(reported_at).format('llll') }, 'inputSuccess'))
    },

    willUpdate: (props, nextProps)=> {
      // re-generate skipRows object whenever selected kpis has been changed or aggregationType, tableSelectedDate, tableStartDate, tableEndDate has been changed
      if (props.kpis && nextProps.kpis && props.kpis.length != nextProps.kpis.length ||
        props.kpiUI.aggregationType != nextProps.kpiUI.aggregationType ||
        props.kpiUI.tableSelectedDate != nextProps.kpiUI.tableSelectedDate ||
        props.kpiUI.tableStartDate != nextProps.kpiUI.tableStartDate ||
        props.kpiUI.tableEndDate != nextProps.kpiUI.tableEndDate) {
        const skipRows = initTotalSkipRows(
          nextProps.selectedKPIs,
          nextProps.kpis,
          nextProps.selected_user_id,
          nextProps.kpiUI.aggregationType,
          moment(nextProps.kpiUI.tableSelectedDate).format('YYYY-MM-DD'),
          moment(nextProps.kpiUI.tableStartDate).format('YYYY-MM-DD'),
          moment(nextProps.kpiUI.tableEndDate).format('YYYY-MM-DD')
        )
        nextProps.updateUI({ skipRows: skipRows })
      }
      if (props.isUpdating && !nextProps.isUpdating && !nextProps.isUpdateFailed) {
        nextProps.updateUI({ editRows: [] })
      }
    },
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: {
    editRows: [],
    skipRows: (props)=> props.selectedKPIs && props.kpis && initTotalSkipRows(
      props.selectedKPIs,
      props.kpis,
      props.selected_user_id,
      props.kpiUI.aggregationType,
      moment(props.kpiUI.tableSelectedDate).format('YYYY-MM-DD'),
      moment(props.kpiUI.tableStartDate).format('YYYY-MM-DD'),
      moment(props.kpiUI.tableEndDate).format('YYYY-MM-DD')) || undefined,
  }}),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/kpi-chart-detail-table.js